import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
// import { Store } from '@ngrx/store';

import { BackendService, FORM_STEPS } from './../../shared/index';

@Injectable()
export class NavGuard implements CanActivate {
  activeStep;
  completedSteps;
  storeData;

  constructor(
    // private _store: Store<any>,
    private _backend: BackendService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<any> {
    return this._backend.getAllFormData().then((data) => {
      // set completed steps
      this.completedSteps = Object.keys(data);
      // set active step
      this.activeStep = FORM_STEPS.map(step => step.id).reduce((prev, curr) => {
        if (this.completedSteps.includes(curr) || prev !== '') {
          return prev;
        } else {
          return curr;
        }
      }, '');
      return this.activeStep === route.url[0].path || this.completedSteps.includes(route.url[0].path);
    });
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./resources/themes/pandax/bobtail/app/coverage-form/navigation/navigation-guard.service.ts